var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod"},[_c('upLoadImg',{attrs:{"filesList":_vm.imgList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }